// Live case-study data from the CMS (/api/cases), with the static cases.js as a
// graceful fallback so the site never breaks if the backend is unreachable.
import { useState, useEffect } from "react";
import { CASE_STUDIES, getCase } from "./cases";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _promise = null;

export const invalidateCases = () => { _cache = null; _promise = null; };

export const loadCases = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${API}/cases`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((d) => {
        const list = d.cases || [];
        _cache = list.length ? list : CASE_STUDIES;
        return _cache;
      })
      .catch(() => { _cache = CASE_STUDIES; return CASE_STUDIES; });
  }
  return _promise;
};

export const useCases = () => {
  const [cases, setCases] = useState(_cache || CASE_STUDIES);
  useEffect(() => {
    let alive = true;
    loadCases().then((c) => alive && setCases(c));
    return () => { alive = false; };
  }, []);
  return cases;
};

export const useCase = (slug, previewToken) => {
  const [state, setState] = useState(() => {
    const cached = !previewToken && _cache && _cache.find((c) => c.slug === slug);
    return { loading: !cached, item: cached || null };
  });
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    const url = previewToken
      ? `${API}/preview/case/${slug}?token=${encodeURIComponent(previewToken)}`
      : `${API}/cases/${slug}`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((c) => { if (alive) setState({ loading: false, item: c || (previewToken ? null : getCase(slug)) || null }); })
      .catch(() => { if (alive) setState({ loading: false, item: (previewToken ? null : getCase(slug)) || null }); });
    return () => { alive = false; };
  }, [slug, previewToken]);
  return state;
};
